import { render, staticRenderFns } from "./goAila.vue?vue&type=template&id=273e8cdc&scoped=true"
import script from "./goAila.vue?vue&type=script&lang=js"
export * from "./goAila.vue?vue&type=script&lang=js"
import style0 from "./goAila.vue?vue&type=style&index=0&id=273e8cdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e8cdc",
  null
  
)

export default component.exports